import React, { Component } from "react";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/todo.json"


import { ROLES } from "constant"
import { ajaxPutStrapi } from "../../helpers/ajax";


export default class Todo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }

    componentDidMount = () => {

    }

    setComplete = (data) => {
        let formdata = {}
        formdata["completato"] = !data.completato;
        formdata = { "data": formdata };
        ajaxPutStrapi("todos/"+data.id, formdata,this.setCompleteCallback)
    }

    setCompleteCallback = () => {
        if (this.ref) {
            this.ref.loadData()
        }
    }

    render() {

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione Assegnazioni"}
                    subtitle={"TO DO LIST"}
                    icon={"checklist"}
                    backButton={this.props.backFunction}
                />

                <MDBox>
                    <MyDataTable
                        ref={(ref) => this.ref = ref}
                        defaultSort={"sort[0]=completato:asc&sort[1]=data_consegna"}
                        tableData={tableData}
                        edit={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        delete={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        add={[ROLES.admin, ROLES.ufficio_tecnico, ROLES.PM].includes(global.user.ruolo) ? true : false}
                        icon={"Personale"}
                        customAction={
                            [
                                {
                                    icon: "check",
                                    color: "success",
                                    function: this.setComplete
                                }
                            ]}

                    />
                </MDBox>

            </DashboardLayout>
        )
    }
}


